<template>
  <piece-card title="僧寮动态">
    <div class="sl-body">
      <TabsCard v-model="active" :list="list" size="mini" :gap="6" />
      <div class="room-list flex-box">
        <InfoCard
          v-for="(item, index) in infoList"
          :key="index"
          :title="item.title"
          :value="item.value"
          class="info-item flex-grow"
        />
      </div>
    </div>
  </piece-card>
</template>

<script>
import PieceCard from "../../components/piece-card.vue";
import TabsCard from "../../components/tabs-card.vue";
import InfoCard from "../../components/info-card.vue";

const defaultValue = {
  jxj: {
    total: 50,
    use: 30,
    rest: 20,
  },
  qyx: {
    total: 40,
    use: 25,
    rest: 15,
  },
  stx: {
    total: 60,
    use: 35,
    rest: 25,
  },
  fxj: {
    total: 30,
    use: 20,
    rest: 10,
  },
  yzx: {
    total: 45,
    use: 20,
    rest: 25,
  },
};

export default {
  name: "SengLiao",
  components: {
    PieceCard,
    TabsCard,
    InfoCard,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {
      list: [
        { label: "静心居", value: "jxj" },
        { label: "青云轩", value: "qyx" },
        { label: "松涛轩", value: "stx" },
        { label: "佛香居", value: "fxj" },
        { label: "云中轩", value: "yzx" },
      ],
      active: "jxj",
    };
  },
  computed: {
    room() {
      return defaultValue[this.active] || {};
    },
    infoList() {
      const room = this.room;
      return [
        { title: "房间使用情况", value: `${room.rest || 0}/${room.total || 0}` },
        { title: "总入住人数", value: room.use || 0 },
      ];
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.sl-body {
  padding-top: 10px;
}
.room-list {
  margin-top: 10px;
}
.info-item {
  &:not(:last-of-type) {
    margin-right: 5px;
  }
}
</style>
